import * as React from "react";

const IconHeaderNavDropdownDown: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 9 6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fill="currentColor"
                d="M4.5 5.5a.747.747 0 01-.53-.22L.22 1.53A.75.75 0 111.28.47L4.5 3.69 7.72.47a.75.75 0 111.06 1.06L5.03 5.28a.748.748 0 01-.53.22z"
            />
        </svg>
    );
};

export default React.memo(IconHeaderNavDropdownDown);
